import React, { useState } from 'react'
import { Helmet } from 'react-helmet'
import { useTEPopups } from 'react-tec'

import { sendForgotPasswordEmail } from './requests'
import { PanelWrapper, Panel, Form, Title, SignIn, Input, Button } from './styledComponents'

export const ForgotPassword = () => {
	const popupFunctions = useTEPopups()
	const [email, setEmail] = useState('')

	const handleForgotPasswordSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
		e.preventDefault()
		try {
			const data = { email, popupFunctions }
			await sendForgotPasswordEmail(data)
			setEmail('')
		} catch (e) {
			console.log(e)
		}
	}

	const meta = {
		title: 'RCMS Soft./styledComponentsorgot Password',
		description: 'Standardizing, Digitizing, and Automating',
	}

	return (
		<>
			<Helmet {...meta} />
			<PanelWrapper>
				<Panel>
					<Form onSubmit={handleForgotPasswordSubmit}>
						<Title>Forgot Password</Title>
						<SignIn to='/signIn'>Sign In?</SignIn>
						<Input
							type='email'
							labelForKey='email'
							placeholder='Email'
							value={email}
							onChange={(e) => setEmail(e.target.value)}
							required
						/>
						<Button type='submit'>Submit</Button>
					</Form>
				</Panel>
			</PanelWrapper>
		</>
	)
}
